module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-Light_V1000.04c8da6f.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-Light_V1000.eot
// module id = 655
// module chunks = 0